module.exports = global["surveylab_monitor_monitorSelector"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./monitor-selector.ts");